import React, { useState } from 'react';
import { DatePicker, ConfigProvider, Table } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import locale from 'antd/es/locale/ko_KR';
import axios from 'axios';
import '../styles/Common.css'; // 공통 스타일

const { MonthPicker } = DatePicker;

dayjs.locale('ko'); // dayjs 로케일 설정

const API_KEY = 'AIzaSyA28MYWVEuilSfYo4BwTR-ly_0Xqwq06I0';
const SPREADSHEET_ID = '1GL_jqQA_XrmvZpfKkwbAHfzaLoMfPOvYoOxCxTenvuo';

const MealPage = () => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState(null);

  const loadSheetsData = async (date) => {
    const formattedDate = date.format('YYYY-M월');
    const sheetName = `${formattedDate}`;
    const url = `https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${sheetName}?key=${API_KEY}`;
    
    try {
      const response = await axios.get(url);
      const sheetData = response.data.values;
      if (sheetData) {
        const columnsData = sheetData[1].map((header, index) => ({
          title: header,
          dataIndex: `col${index}`,
          key: `col${index}`,
        }));

        const rowData = sheetData.slice(3).map((row, rowIndex) => {
          const rowObject = { key: rowIndex };
          row.forEach((cell, cellIndex) => {
            rowObject[`col${cellIndex}`] = cell;
          });
          return rowObject;
        });

        setColumns(columnsData);
        setData(rowData);
        setError(null);
      } else {
        setError('No data found in the spreadsheet.');
        setData([]);
        setColumns([]);
      }
    } catch (error) {
      console.error('Error loading Google Sheets data', error);
      setError('Google Sheets 데이터를 불러오는 중 오류가 발생했습니다.');
      setData([]);
      setColumns([]);
    }
  };

  const handleDateChange = (date) => {
    if (date) {
      loadSheetsData(date);
    }
  };

  const getRowClassName = (record) => {
    return record.col1 === '토' || record.col1 === '일' ? 'weekend-row' : '';
  };

  return (
    <ConfigProvider locale={locale}>
      <div className="common-container">
        <h2>식사 내역</h2>
        <div style={{ marginTop: 20 }}>
          <MonthPicker 
            onChange={handleDateChange} 
            placeholder="연도와 월을 선택하세요" 
            style={{ width: '100%', maxWidth: 300 }} 
            format="YYYY년 MM월" // 날짜 형식을 한글로 설정
          />
        </div>
        <div style={{ marginTop: 20 }}>
          {error ? (
            <p style={{ color: 'red' }}>{error}</p>
          ) : (
            <Table
              columns={columns}
              dataSource={data}
              pagination={false} // 페이징을 비활성화하여 한 페이지에 모든 데이터 표시
              rowKey="key" // 고유한 키 설정
              rowClassName={getRowClassName} // 행 클래스 설정
            />
          )}
        </div>
      </div>
    </ConfigProvider>
  );
};

export default MealPage;
